import React from "react";
import Container from "../General/Container/Container";
import MinifiedCollapse from "./MinifiedCollapse";
import { useSelector } from "react-redux";
import MinifiedInsightsDetailsModal from "../Modal/Minified/MinifiedInsightsDetailsModal";
import MinifiedRecommended from "./MinifiedRecommended";
import MinifiedResultSummary from "./MinifiedResultSummary";

const MinifiedResultDashboard = ({
    resultDataObj,
    summary,
    recommendedData,
    onChangeAudienceName,
    heActiveKeys,
    setHeActiveKeys,
    aiActiveKeys,
    setAiActiveKeys,
    selectedRowKeysHe,
    setSelectedRowKeysHe,
    selectedRowKeysAi,
    setSelectedRowKeysAi
}) => {
    const { visibleRecommendedInsightsModal } = useSelector((state) => state.minified)
    return <>
        <MinifiedResultSummary summary={summary} />
        <MinifiedRecommended
            data={recommendedData}
            setHeActiveKeys={setHeActiveKeys}
            setAiActiveKeys={setAiActiveKeys}
            onChangeName={onChangeAudienceName}
        />
        <Container className="drow align-start gap-1">
            {resultDataObj.he.length ? <MinifiedCollapse
                list={resultDataObj.he}
                activeKey={heActiveKeys}
                selected={selectedRowKeysHe}
                setSelected={setSelectedRowKeysHe}
                onChange={setHeActiveKeys} /> : null}

            {resultDataObj.ai.length ? <MinifiedCollapse
                list={resultDataObj.ai}
                activeKey={aiActiveKeys}
                selected={selectedRowKeysAi}
                setSelected={setSelectedRowKeysAi}
                onChange={setAiActiveKeys}
                type="ai" /> : null}
        </Container>
        {visibleRecommendedInsightsModal.visible ? <MinifiedInsightsDetailsModal /> : null}
    </>
}

export default MinifiedResultDashboard